import { existingPaymentSystems } from "../constants/existingPaymentSystems";
import { bankLogos, paymentProvidersOptions } from "../containers/SeasonPass/constants";

export const getVisibleBankLogos = (eventData) => {
    if (eventData) {
      const availablePaymentSystems = paymentProvidersOptions.filter(ppo => {
        return eventData.allowedPaymentProviders.some(paySystem => ppo.id === paySystem.providerId)
      }).map(pp => {
        return pp.label
      });

      return bankLogos.filter(bl => {
        var res = availablePaymentSystems.some(aps => bl.logoFor.includes(aps));
        return res;
      });
    }

    return [];
  };
